import { Instance, types } from 'mobx-state-tree'
import { IsEditingModel } from '../IsEditingModel'

export const RoleModel = IsEditingModel.named('UserBaseModel')
  .props({
    value: types.identifier,
    text: types.string,
  })

export type Role = Instance<typeof RoleModel>
